// extracted by mini-css-extract-plugin
export default {"tileContainer":"TileSmallWithImg-module__tileContainer__U4hDG","imgContainer":"TileSmallWithImg-module__imgContainer__sPyV7","title":"TileSmallWithImg-module__title__GFidG"};